export default {
  Enter: "Enter",
  Tab: "Tab",
  Left: "ArrowLeft",
  Right: "ArrowRight",
  Up: "ArrowUp",
  Down: "ArrowDown",
  Escape: "Escape",
  Comma: ",",
  Period: ".",
  Minus: "-",
  Delete: "Delete",
  Backspace: "Backspace",
  Meta: "Meta",
  Ctrl: "Control",
  Space: " "
};
